import MyCourseCard from "../component/MyCourseComponent/MyCourseCard";
import { useEffect, useState } from "react";
import { getAllCourseOfStudent, getAllScormCourseOfStudent } from "../helper/student_helper";
import { toast } from "react-toastify";
import { generatePresignedUrlForAccess } from "../helper/content_helper";
import { useNavigate } from "react-router-dom";
import MyScormCourseCard from "../component/MyCourseComponent/MyScormCourseCard";
import { Grid } from "@mui/material";

const TABS = [
    { label: "Normal Courses", value: "normal" },
    { label: "SCORM Courses", value: "scorm" }
];

const MyCourses = () => {
    const [allCourse, setAllCourse] = useState([]);
    const [allScormCourse, setAllScormCourse] = useState([]);
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const [selectedTab, setSelectedTab] = useState("scorm");

    const fetchCourses = async () => {
        try {
            setLoader(true);
            const id = JSON.parse(localStorage.getItem('student'))?.id;
            const data = await getAllCourseOfStudent(id);
            if (data?.success) {
                if (data?.enrollResult?.length > 0) {
                    updateThubmnail(data?.enrollResult);
                }
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    }

    const fetchScormCourses = async () => {
        try {
            setLoader(true);
            const id = JSON.parse(localStorage.getItem('student'))?.id;
            const data = await getAllScormCourseOfStudent(id);
            if (data?.success) {
                if (data?.scormCourses?.length > 0) {
                    let updateData = await updateScormThubmnail(data?.scormCourses);
                    setAllScormCourse(updateData);
                }
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    }

    const updateScormThubmnail = async (data) => {
        const updateData = await Promise.all(
            data.map(async (d) => {
                if (d?.thumbnail) {
                    let name = d.thumbnail;
                    let type = "image";
                    const response = await generatePresignedUrlForAccess({ name, type });

                    if (response.success) {
                        return {
                            ...d,
                            thumbnailUrl: response.presignedUrl,
                        };
                    } else {
                        console.error('Error generating pre-signed URL for', d.thumbnail);
                        return d;
                    }
                }
                return d;
            })
        );

        return updateData;
    }

    const updateThubmnail = async (data) => {
        console.log("recive data", data)
        const updateData = await Promise.all(
            data?.map(async (d) => {
                if (d?.courseDto?.thumbnailName) {
                    let name = d.courseDto.thumbnailName;
                    let type = "image";
                    const response = await generatePresignedUrlForAccess({ name, type });

                    if (response.success) {
                        return {
                            ...d,
                            courseDto: {
                                ...d.courseDto,
                                thumbnailUrl: response.presignedUrl,
                            },
                        };
                    } else {
                        console.error('Error generating pre-signed URL for', d.courseDto.thumbnailName);
                        return d;
                    }
                }
                return d;
            })
        );

        console.log("updateed data ", updateData)

        setAllCourse(updateData);
    }

    useEffect(() => {
        const student = localStorage.getItem('student');

        if (!student) {
            navigate('/login');
        } else {
            fetchCourses();
            fetchScormCourses();
        }
    }, [navigate]);

    return (
        <div className="container" style={{ padding: '2rem 1rem' }}>
            <h1 className="mb-2">My Courses</h1>

            {/* Tab Selector */}
            <div style={{
                display: "flex",
                borderBottom: "1px solid #ddd",
                marginBottom: "2rem"
            }}>
                {TABS.map((tab) => (
                    <button
                        key={tab.value}
                        style={{
                            border: "none",
                            outline: "none",
                            background: selectedTab === tab.value ? "#292b4d" : "white",
                            color: selectedTab === tab.value ? "white" : "#333",
                            padding: "10px 24px",
                            marginRight: "4px",
                            borderRadius: "6px 6px 0 0",
                            cursor: "pointer",
                            fontWeight: "bold"
                        }}
                        onClick={() => setSelectedTab(tab.value)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Loading indicator */}
            {loader && <div>Loading...</div>}

            {selectedTab === "normal" && (
                <div className="d-flex flex-wrap gap-3">
                    {allCourse?.length > 0 ? (
                        allCourse.map((course, index) => (
                            <MyCourseCard course={course?.courseDto} key={index} />
                        ))
                    ) : (
                        !loader && (
                            <div
                                style={{
                                    fontSize: "18px",
                                    fontWeight: "bold",
                                    color: "#777",
                                    textAlign: "center",
                                    width: "100%",
                                    marginTop: "20px",
                                }}
                            >
                                No courses available
                            </div>
                        )
                    )}
                </div>
            )}

            {selectedTab === "scorm" && (
                <>
                    <Grid container spacing={4}>
                        {allScormCourse?.length > 0 ? (
                            allScormCourse.map((course, index) => (
                                <MyScormCourseCard course={course} key={index} />
                            ))
                        ) : (
                            !loader && (
                                <div
                                    style={{
                                        fontSize: "18px",
                                        fontWeight: "bold",
                                        color: "#777",
                                        textAlign: "center",
                                        width: "100%",
                                        marginTop: "20px",
                                    }}
                                >
                                    No SCORM courses available
                                </div>
                            )
                        )}
                    </Grid>
                </>
            )}
        </div>
    )
}

export default MyCourses;
